(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65781,93812,7797,5783,56012,75978,91058,99257,33030],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 80935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6572);
/* harmony import */ var UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56362);
/* harmony import */ var UI_components_SectionTitle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15805);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var UI_components_Illustration__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93812);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58117);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);










var Works = function(param) {
    var section = param.section, type = param.type;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getDocumentFields */ .OA)(section, [
            "title",
            "description",
            "contentModules", 
        ]);
    }, [
        section
    ]), title = ref.title, description = ref.description, contentModules = ref.contentModules;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getItemsByType */ .XM)(contentModules, "block", [
        "contentModules", 
    ]), 1), projectsData = ref1[0];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getItemsByType */ .XM)(contentModules, "link", [
        "buttonTitle",
        "url"
    ]), 1), link = ref2[0];
    var projects = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return projectsData === null || projectsData === void 0 ? void 0 : projectsData.contentModules.map(function(project) {
            var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getDocumentFields */ .OA)(project, [
                "title",
                "description",
                "images",
                "contentList", 
            ]), projectTitle = ref.title, projectDescription = ref.description, images = ref.images, contentList = ref.contentList;
            var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getImage */ .gJ)(images === null || images === void 0 ? void 0 : images[0]), video = ref1.url;
            return {
                projectTitle: projectTitle,
                projectDescription: projectDescription,
                video: video,
                path: (contentList === null || contentList === void 0 ? void 0 : contentList[0]) || ""
            };
        });
    }, [
        projectsData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().section), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[type]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_SectionTitle__WEBPACK_IMPORTED_MODULE_7__["default"], {
                title: title,
                description: description,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().titleStyle)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().contentWrapper),
                children: (projects || []).map(function(param) {
                    var path = param.path, video = param.video, ref = param.ref, projectTitle = param.projectTitle, projectDescription = param.projectDescription;
                    var isVideo = video.includes("videos.");
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: path,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().projectWrapper),
                            children: [
                                isVideo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                    ref: ref,
                                    muted: true,
                                    loop: true,
                                    autoPlay: true,
                                    playsInline: true,
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().video),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        src: video,
                                        type: "video/mp4"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Illustration__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                    src: video,
                                    alt: projectTitle,
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().video)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().descriptionContainer),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                            children: projectTitle
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description),
                                            children: projectDescription
                                        })
                                    ]
                                })
                            ]
                        })
                    }, path);
                })
            }),
            link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                path: link.url,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().link),
                children: link.buttonTitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Works);


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 58117:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__TkKbb","titleStyle":"styles_titleStyle__oudA2","contentWrapper":"styles_contentWrapper__pkl66","projectWrapper":"styles_projectWrapper__s9noc","descriptionContainer":"styles_descriptionContainer__oIM9L","project":"styles_project__HQ22m","video":"styles_video__v9606","imagesList":"styles_imagesList__UpqS2","link":"styles_link__JVdu_","services":"styles_services__E6tx7","title":"styles_title__8gVFQ","description":"styles_description__ZJqTm","newhomepage":"styles_newhomepage__zPX2s"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);